import { useState } from "react";
import { Link } from "react-router-dom";
import { navLinks } from "@/mocks/articles";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    const formData = new FormData(form);
    try {
      await fetch("https://readdy.ai/api/form/d914bdk6ci2plld1oiig", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
    } catch (e) {
      // silently handle
    }
    setSubmitted(true);
    setEmail("");
  };

  return (
    <footer className="bg-accent-500 rounded-2xl mx-4 md:mx-6 mb-6 mt-16" aria-label="页脚">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          {/* Left - Newsletter */}
          <div className="md:col-span-5">
            <h2 className="text-3xl md:text-4xl font-heading font-light text-background-50 tracking-tight">
              不错过<br />任何一线吃瓜
            </h2>
            <p className="mt-4 text-foreground-300 text-sm leading-relaxed max-w-sm">
              订阅51黑料网每日简报，第一时间获取最新爆料推送，吃瓜快人一步。
            </p>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="mt-6"
            >
              <input
                type="text"
                name="website_alt"
                className="form-website-alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱地址"
                  className="flex-1 bg-transparent border-b border-foreground-400/40 px-1 py-2 text-sm text-background-50 placeholder:text-foreground-400 outline-none focus:border-background-50 transition-colors"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap px-5 py-2 rounded-full bg-background-50 text-accent-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer"
                >
                  订阅 <i className="ri-arrow-right-line ml-1 text-xs"></i>
                </button>
              </div>
              {submitted && (
                <p className="mt-2 text-xs text-background-50/70">订阅成功！感谢关注。</p>
              )}
            </form>
          </div>

          {/* Middle - Quick Links */}
          <div className="md:col-span-3">
            <h3 className="text-xs font-medium text-background-50/50 uppercase tracking-wider mb-5">快速导航</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/80 hover:text-background-50 border-b border-background-50/20 hover:border-background-50/60 transition-colors pb-0.5 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Right - Contact Info */}
          <div className="md:col-span-4">
            <h3 className="text-xs font-medium text-background-50/50 uppercase tracking-wider mb-5">联系我们</h3>
            <div className="space-y-3 text-sm text-background-50/80">
              <p>
                <i className="ri-phone-line mr-2 text-background-50/50 w-4 h-4 inline-flex items-center justify-center"></i>
                400-888-9999
              </p>
              <p>
                <i className="ri-mail-line mr-2 text-background-50/50 w-4 h-4 inline-flex items-center justify-center"></i>
                tips@bxubjgt.cn
              </p>
            </div>
            <div className="mt-8">
              <h3 className="text-xs font-medium text-background-50/50 uppercase tracking-wider mb-3">公司地址</h3>
              <p className="text-sm text-background-50/80 leading-relaxed">
                北京市朝阳区建国路88号<br />SOHO现代城A座1208室
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-50/10 px-6 md:px-10 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-5 text-sm">
            <a href="#" className="text-background-50/60 hover:text-background-50 transition-colors border-b border-background-50/20 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-background-50/60 hover:text-background-50 transition-colors border-b border-background-50/20 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-background-50/60 hover:text-background-50 transition-colors border-b border-background-50/20 cursor-pointer" aria-label="抖音">
              <i className="ri-tiktok-line"></i>
            </a>
          </div>
          <p className="text-xs text-background-50/40 whitespace-nowrap">
            &copy; 2026 51黑料网 bxubjgt.cn. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs">
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors border-b border-background-50/20 cursor-pointer">隐私政策</a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors border-b border-background-50/20 cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
